import { ToastContainer, toast } from "react-toastify";
import { injectStyle } from "react-toastify/dist/inject-style";

if (typeof window !== "undefined") {
  injectStyle();
}

const toastNotify = (message, type) => {
  toast.dark(message, {
    type: type,
    position: "bottom-right",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
  });
};

const handleResponse = (response) => {
  if (!response) return toastNotify("Network Error!", "error");
  if (response?.status === -1)
    return toastNotify(response?.message, response?.type);
  if (response?.status === 200)
    return toastNotify(response?.data.message, "success");
  if (response?.status === 413)
    return toastNotify("Photo harus kurang dari 1mb", "error");
  if (response?.status === 400)
    return toastNotify(
      response?.data.message
        ? response?.data.message
        : response?.data.error
        ? response?.data.error
        : response?.data,
      "error"
    );
  if (response?.status === 401) return toastNotify("Unauthorized", "error");
  if (response?.status === 404) return toastNotify("Not Found", "error");
  if (response?.status === 500)
    return toastNotify("Internal Server Error", "error");
  if (response?.status !== 200)
    return toastNotify(response?.data.error, "error");
};

const tabelIst = (skor) => {
  if (parseInt(skor) <= 10) return "Sangat Rendah";
  else if (parseInt(skor) <= 50) return "Rendah";
  else if (parseInt(skor) <= 88) return "Dibawah Rata-Rata";
  else if (parseInt(skor) <= 110) return "Rata-Rata";
  else if (parseInt(skor) <= 130) return "Diatas Rata-Rata";
  else if (parseInt(skor) <= 168) return "Superior";
  else if (parseInt(skor) <= 180) return "Sangat Superior";
};

export { ToastContainer, toastNotify, handleResponse, tabelIst };
